import { getLatestVersion } from '@/entities/AppService'
import { isFetchResultSuccessful } from '@/entities/FetchResult'
import { TypedDispatch } from '@/store'

import { version as currentVersion } from '../../../package.json'
import {
    setCurrentVersion,
    setError,
    setIsLoading,
    setLatestVersion,
} from './appReducer'

export const fetchAppVersions = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(undefined))

    try {
        const latestVersionResponse = await getLatestVersion()

        if (! isFetchResultSuccessful(latestVersionResponse)) {
            dispatch(setError({
                status: latestVersionResponse.status,
                title: latestVersionResponse.error,
            }))
            return
        }

        const latestVersion = latestVersionResponse.data

        dispatch(setCurrentVersion(currentVersion))
        dispatch(setLatestVersion(latestVersion))
    } catch (error) {
        console.error('[fetchAppVersions]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
